<script>
import GroupResource from '@/resources/group'
import CarResource from '@/resources/car'

export default {
    components: {},
    computed: {
        resources() {
            if (!this.pageData) {
                return []
            }

            return this.pageData.resources
        },
        filters() {
            const filters = { search: this.searchQuery }

            if (this.selectedGroup) {
                filters.groups = this.selectedGroup
            }

            return filters
        },
        carDetails() {
            if (!this.previewingCar) {
                return []
            }

            const attributes = this.previewingCar.attributes

            return [
                ['Brand', attributes.brand],
                ['Year', attributes.year],
                ['Country', attributes.country],
                ['Horsepower', attributes.horsepower],
                ['Torque', attributes.torque],
                ['Weight', attributes.weight],
                ['Power / Weight', attributes.power_to_weight],
            ].filter((row) => row[1] !== null && row[1] !== undefined && row[1] !== '')
        },
    },
    watch: {},
    data() {
        return {
            loading: true,
            pageData: null,
            searchQuery: '',
            groupResources: [],
            selectedGroup: '',
            previewingCar: null,
        }
    },
    methods: {
        async search() {
            this.loading = true
            this.pageData = await CarResource.list({ resolveRelated: true, query: this.filters })
            this.loading = false
        },
        modalSelectGroup(groupId) {
            this.selectedGroup = groupId
            this.$refs.groupModal.hide()
        },
        onGroupBadgeClick(groupId) {
            this.selectedGroup = groupId
            this.searchQuery = ''
            this.search()
        },
        async prevPage() {
            this.pageData = await this.pageData.prevPage()
            await Promise.all(this.pageData.resources.map((resource) => resource.resolveRelated()))
            window.scrollTo(0, 0)
        },
        async nextPage() {
            this.pageData = await this.pageData.nextPage()
            await Promise.all(this.pageData.resources.map((resource) => resource.resolveRelated()))
            window.scrollTo(0, 0)
        },
    },
    async mounted() {
        this.groupResources = await GroupResource.all()
        await this.search()
    },
}
</script>

<template>
    <div>
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <router-link class="nav-link active" :to="{ name: 'availabilityCars' }">Voitures disponibles</router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'availabilityTracks' }">Circuits disponibles</router-link>
            </li>
        </ul>

        <b-form @submit.prevent="search()" ref="searchForm" class="mt-3">
            <b-input-group size="sm">
                <b-input v-model="searchQuery" placeholder="Mots-clés"></b-input>
                <template #append>
                    <b-button variant="outline-primary" @click="$refs.groupModal.show()"
                        >Groupe : <strong>{{ selectedGroup || 'Tous' }}</strong></b-button
                    >
                    <b-button variant="primary" type="submit">Rechercher</b-button>
                </template>
            </b-input-group>
        </b-form>

        <hr />

        <b-table-simple v-if="!loading" class="nowrap-table" bordered striped responsive>
            <b-thead>
                <b-tr>
                    <b-th>Nom de la voiture</b-th>
                    <b-th>Groupes de course</b-th>
                    <b-th>Temps total</b-th>
                </b-tr>
            </b-thead>

            <b-tbody v-if="resources.length > 0">
                <b-tr v-for="(car, i) in resources" :key="i">
                    <b-td class="font-weight-bold"><a href="javascript:{};" @click="previewingCar = car">{{ car.attributes.name }}</a></b-td>
                    <b-td>
                        <span v-if="car.rel('groups').resources.length">
                            <b-badge variant="secondary" class="mr-2" v-for="(group, j) in car.rel('groups').resources" :key="j" href="javascript:{}" @click="onGroupBadgeClick(group.id)">{{ group.attributes.name }}</b-badge>
                        </span>
                        <span v-else class="text-muted">Aucun</span>
                    </b-td>
                    <b-td>{{ car.getTotalTimePretty() }}</b-td>
                </b-tr>
            </b-tbody>

            <b-tbody v-else>
                <b-tr>
                    <b-td colspan="4" class="text-center">
                        <p class="py-5">Aucune voiture ne correspond à votre recherche</p>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <div v-else>
            <hr />
            <b-skeleton-table :rows="5" :columns="4" :table-props="{ bordered: true, striped: true }" />
        </div>

        <p class="text-center text-muted" v-if="pageData && pageData.pages > 1">
            <small>
                <b-button variant="link" @click="prevPage()" :disabled="pageData.page == 1"><b-icon icon="caret-left-square" /></b-button>
                <b-button variant="link" @click="nextPage()" :disabled="pageData.page >= pageData.pages" class="ml-3"><b-icon icon="caret-right-square" /></b-button>
            </small>
        </p>

        <!-- Modals -->
        <b-modal ref="groupModal" title="Filtrer par groupe" size="md" hide-footer no-fade centered>
            <b-list-group>
                <b-list-group-item href="javascript:{}" @click="modalSelectGroup('')">Tous</b-list-group-item>
                <b-list-group-item v-for="(groupResource, i) in groupResources" :key="i" @click="modalSelectGroup(groupResource.id)" :active="selectedGroup == groupResource.id" href="javascript:{}">{{ groupResource.attributes.name }}</b-list-group-item>
            </b-list-group>
        </b-modal>

        <b-modal v-if="previewingCar" visible :title="previewingCar.attributes.name" size="lg" @hide="previewingCar = null" hide-footer no-fade centered>
            <b-row>
                <b-col md="6" class="mb-3 mb-md-0">
                    <b-img v-if="previewingCar.attributes.content_preview_url" :src="previewingCar.attributes.content_preview_url" fluid rounded alt="Aperçu de la livrée par défaut" />
                    <div v-else class="sa-empty">Aucun aperçu disponible pour cette voiture.</div>
                </b-col>
                <b-col>
                    <dl class="row mb-0">
                        <template v-for="row in carDetails">
                            <dt :key="`${row[0]}-t`" class="col-5 text-muted">{{ row[0] }}</dt>
                            <dd :key="`${row[0]}-d`" class="col-7">{{ row[1] }}</dd>
                        </template>
                        <dt class="col-5 text-muted">Temps de course</dt>
                        <dd class="col-7">{{ previewingCar.getTotalTimePretty() }}</dd>
                    </dl>
                    <div v-if="previewingCar.rel('groups').resources.length" class="mt-3">
                        <div class="text-muted small mb-1">Groupes de course</div>
                        <b-badge v-for="(group, j) in previewingCar.rel('groups').resources" :key="j" variant="secondary" class="mr-1">{{ group.attributes.name }}</b-badge>
                    </div>
                </b-col>
            </b-row>
            <template v-if="previewingCar.attributes.description">
                <hr />
                <p class="mb-0" v-html="previewingCar.attributes.description"></p>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
.nowrap-table {
    td,
    th {
        white-space: nowrap;
        max-width: 300px;
        overflow: hidden;
    }
}
</style>
